import { atom } from "recoil";

// 订单数
export const OrderCount = atom({
  key: 'OrderCount',
  default: {
    total: '', // 总订单数
    order: '', // 已接单数
  },
});